<template>
  <div>
    <el-table
      :data="subscribeList"
      class="table-theme--order"
      header-row-class-name="header-row-theme--order"
      header-cell-class-name="header-cell-theme--order"
      row-class-name="cell-row-theme--order"
      cell-class-name="cell-cell-theme--order"
      :span-method="spanMethod"
      border
      style="width: 100%"
      :key="orderNo"
    >
      <!-- 订阅名称 -->
      <el-table-column
        prop="subscribeName"
        label="订阅名称"
        width="180"
        class-name="table-column"
        label-class-name="table-column"
      >
      </el-table-column>
      <!-- 规格 -->
      <el-table-column
        label="规格"
        width="180"
        class-name="table-column"
        label-class-name="table-column"
      >
        <template slot-scope="scope">
          <div>{{scope.row.specQuantity}}{{scope.row.unitShow}}</div>
        </template>
      </el-table-column>
      <!-- 服务有效期/月 -->
      <el-table-column prop="servicePeriod" label="服务有效期/月"></el-table-column>
      <!-- 已使用量 -->
      <el-table-column
        prop="usedQuantity"
        label="已使用量"
        class-name="table-column"
        label-class-name="table-column"
      ></el-table-column>
      <!-- 当前余量 -->
      <el-table-column prop="availableQuantity" label="当前余量"></el-table-column>
      <!-- 付款状态 -->
      <el-table-column label="付款状态">
        <template>
          <div>{{paymentStatusShow}}</div>
        </template>
      </el-table-column>
      <!-- 操作 -->
      <el-table-column :key="key" label="操作">
        <template>
          <div v-if="trial==1">---</div>
          <div v-else>
            <!-- 待支付 -->
            <div v-if="paymentStatus==10 && status!=30">
              <div>
                <el-button type="primary" @click="goPay">立即支付</el-button>
              </div>
              <div class="cancelButton" @click="cancelPayOrder">取消订单</div>
            </div>
            <!-- 已支付 -->
            <div v-if="paymentStatus==20">
              <!-- 暂时没有开票功能， 隐藏 -->
              <div style="margin-bottom:12px;" v-if="false">
                <el-button type="primary" @click="dialogFormVisible=true">发票申请</el-button>
                <div class="cancelButton" style="color:#066EB7;font-size: 12px;font-weight: 500;"> 下载发票 </div>
              </div>
              <div
                class="cancelButton"
                style="color:#066EB7;font-size: 12px;"
                v-if="signingStatus==30 && contractHashcode!=null"
              >
                <a :href="onlineUrl + `/order-api/attach/download/${contractHashcode}`" download>查看合同</a>
              </div>

              <div v-if="signingStatus==10 ||signingStatus==20">
                <el-button 
                  class="disableButt"
                  type="primary" 
                  :disabled="signingStatus==20 || isClick"
                  @click="contract"
                >合同申请</el-button>
              </div>
            </div>
            <!-- 交易关闭 -->
            <div v-if="status==30">
              <el-button type="primary" @click="againPay">再次购买</el-button>
            </div>
            <!-- 已支付，待确认到账（转账凭证） -->
            <div v-if="paymentStatus==50">
              <div
                v-if="receipt"
                class="cancelButton"
                style="color:#066EB7;font-size: 12px;font-weight: 500;"
                @click="preview"
              >查看转账凭证</div>
              <div v-else class="cancelButton" style="color:#066EB7;font-size: 12px;">
                <UploadNoShow
                  :acceptType="acceptType"
                  :uploadHandling="false"
                  :fileListArr="imgList"
                  :totalNum="1"
                  :paramsupload="paramsupload"
                  :size="10"
                  maxFiles="最多可上传1个文件"
                  flieSize="单个文件最大不可超过10M"
                  @changeFileList="changeFileList"
                  @getOrderList="getOrderList"
                  :recordsFlag="true"
                  :receipt="receipt"
                  :receiptOrderNo="orderNo"
                ></UploadNoShow>
              </div>

              <el-image-viewer
                class="customer-follow-image-viewer"
                v-if="dialogVisible"
                :on-close="() => (dialogVisible = false)"
                :url-list="[`${this.fileUrl}/preview-static?code=${receipt.hashCode}`]"
              />
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 发票弹框 -->
    <InvoiceDialog 
      :dialogInvoiceVisible ="dialogFormVisible" 
      @getChangeInvoice="getChangeInvoice"
    />
  </div>
</template>

<script>
import { contractApplication, cancelOrder } from "@/utils/api/order";
import { imgRes } from "@/utils/config";
import UploadNoShow from "@/components/cost-center/UploadNoShow.vue";
import { fileUrl, onlineUrl } from "@/utils/config.js";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import InvoiceDialog from '@/components/cost-center/InvoiceDialog'


export default {
  components: {
    UploadNoShow,
    ElImageViewer,
    InvoiceDialog
  },
  props: [
    "subscribeList",
    "signingStatus", //合同状态
    "status", //订单状态
    "trial",
    "orderNo", //订单编号
    "payAmount", //付款金额
    "paymentStatus", // 支付状态
    "paymentStatusShow",
    "type", //套餐类型
    "receipt", //对公支付凭证
    "contractHashcode" ,//合同hashCode
    "orderStatus" ,//订单状态
    "startDate",
    "endDate"
  ],
  data() {
    return {
      psnName: "",
      psnMobile: "",
      imgRes: imgRes,
      dialogFormVisible: false, //发票弹框控制
      // 上传凭证相关
      acceptType: ".jpg, .jpeg, .png,",
      imgList: [],
      paramsupload: {
        source: 92,
        sourceType: 92,
        isCreateThumbnail: false,
        project: "haizol-order-web-online",
        modelType: 6,
        isCreateThumbnail: false,
        picSizeType: 1
      },
      loading: false,
      fileUrl,
      onlineUrl,
      dialogVisible: false, //图片预览控制
      isClick: false,
      key: 0,
    };
  },
  methods: {
    // 接受发票弹框
    getChangeInvoice(val){
      this.dialogFormVisible = val
    },
    getOrderList() {
      this.$emit("getOrderTableList",this.orderStatus,this.startDate,this.endDate);
    },
    preview() {
      this.dialogVisible = true;
    },

    // 当附件上传发生变化时
    changeFileList(arr, flag) {
      this.imgList = arr;
    },
    spanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 5) {
        if (rowIndex % 5 === 0) {
          return [5, 1];
        } else {
          return [0, 0];
        }
      } else if (columnIndex === 6) {
        if (rowIndex % 5 === 0) {
          return [5, 1];
        } else {
          return [0, 1];
        }
      }
    },
    // 合同申请弹框
    contract() {
      this.getContract(this.orderNo);
    },
    // 合同申请接口
    getContract(val) {
      if(this.isClick) return ;
      this.isClick = true;
      this.key++;
      const params = { orderNo: val ? val : "" };
      contractApplication(params)
        .then(res => {
          if (res.rspResult.bizCode == 200) {
            this.psnName = res.data.psnName || "";
            this.psnMobile = res.data.psnMobile || "";
            const h = this.$createElement
            this.$confirm('', '合同申请', {
              message: h('div', null, [
                h(
                  'p',
                  {style: 'marginBottom: 10px;'},
                  `已将电子合同发送至${res.data?.psnName || ''} ${
                    res.data?.psnMobile || ''
                  },请注意查收并进行签署确认。`
                ),
                h('span', {style: 'color: #98a3b7;fontSize: 12px;'}, '电子签名服务提供方为e签宝'),
              ]),
              confirmButtonText: '我知道了',
              center: true,
              showCancelButton: false,
              customClass: 'contract-btn',
              closeOnClickModal:false
            })
            .then(() => {
              this.$emit("getOrderTableList",this.orderStatus,this.startDate,this.endDate, () => {
                this.isClick = false;
                this.key++; 
              });
            })
            .catch((err) => {
              this.$emit("getOrderTableList",this.orderStatus,this.startDate,this.endDate, () => {
                this.isClick = false;
                this.key++; 
              });
            });
          // 代表当前用户没有实名认证，弹出询问框
          } else if(res.rspResult.bizCode === 20004) {
             console.log('合同发送失败');
             this.$alert(
              '申请订单合同前，请先完成企业实名认证',
              '请先完成企业实名认证',
              {
                confirmButtonText: '去完成企业实名认证',
                customClass: 'payment-success-alert',
                callback: (action) => {
                  if (action === 'confirm') {
                    this.$router.push({
                      name: 'boot-page-real-name',
                      query: {
                        ispayment: 1,
                      },
                    })
                  }else{
                    this.isClick = false
                    this.key++;
                    console.log('取消实名认证')
                  }
                },
              }
            )
          } else {
            this.$message.error(res.rspResult.message)
          }
        })
        .catch(err => {
          console.log("合同申请失败", err);
        });

      this.$emit("getOrderTableList",this.orderStatus,this.startDate,this.endDate);
      
    },
    // 取消订单接口
    cancelPayOrder() {
      this.$confirm(`是否取消订单${this.orderNo}`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "order-btn",
        iconClass: "iconfont icon-icon-xinxijingshi",
        autofocus: true
      })
        .then(() => {
          this.orderPay();
        })
        .catch(err => {
          console.error();("取消订单失败",err);
        });
    },
    // 支付订单
    orderPay() {
      const params = {
        orderNo: this.orderNo
      };
      cancelOrder(params)
        .then(res => {
          if (res.rspResult.bizCode == 200) {
            this.$nextTick(()=>{
              this.$emit("getOrderTableList",this.orderStatus,this.startDate,this.endDate);
            })
          }
        })
        .catch(err => {
          console.log("取消订单失败", err);
        });
    },
    // 支付订单
    goPay() {
      this.$router.push(`order-payment/${this.orderNo}`);
    },
    // 再次购买
    againPay() {
      let type = "";
      // if (this.payAmount == 2999) {
      //   type = 0;
      // } else if (this.payAmount == 5999) {
      //   type = 1;
      // } else if (this.payAmount == 8999) {
      //   type = 2;
      // }
      // console.log(this.subscribeList[1].specQuantity)
      // return
      if(this.subscribeList[1].specQuantity == 2000) {
        type = 0;
      } else if (this.subscribeList[1].specQuantity == 5000) {
        type = 1;
      } else if (this.subscribeList[1].specQuantity == 10000) {
        type = 2;
      }
      let url=''
      if([0,1,2].includes(type)){
        url=this.$router.resolve({
          path: "order-submission",
          query: {type,origin: 2,}
        });
      }else{
         url=this.$router.resolve({
          path: "meal-choose",
        });
      }
      window.location.href=url.href
    }
  },
  created(){
    
  }
};
</script>

<style lang="scss" scoped>
@import url("../../assets/css/table-theme-order.scss");
// ::v-deep.el-button.is-disabled:hover {
//   background-color: #83b7db !important;
// }
::v-deep.el-button.is-disabled{
  border-color: #ebeef5 !important;
}

::v-deep .el-table th.el-table__cell {
  .cell{
    color: #16181a !important;
  }
}
::v-deep .el-table td.el-table__cell {
  .cell{
    color: #16181a !important;
  }
}
::v-deep .el-table__row {
  .table-column {
    border-right: none;
  }
}

::v-deep.el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell:nth-child(6n) {
    background-color: transparent;
}
::v-deep.el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell:nth-child(7n) {
    background-color: transparent;
}

.cancelButton {
  width: 80px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  color: #4f5d78;
  font-size: 12px;
  font-family: SourceHanSansCN-Regular;
  cursor: pointer;
}
</style>
<style lang="scss" >
.order-btn {
  width: 520px;
  position: relative;
  padding-bottom: 32px;
  .el-message-box__close {
    margin-top: 16px;
    margin-right: 17px;
  }
  .el-message-box__title {
    margin-top: 21px;
    margin-left: 54px;
    font-family: SourceHanSansCN-Medium;
    font-weight: 500;
    font-size: 16px;
    color: #16181a;
  }
  .el-message-box__content {
    padding-top: 0px;
  }
  .el-message-box__message {
    color: #4f5d78;
    font-family: SourceHanSansCN-Regular;
    font-weight: 400;
    font-size: 14px;
    margin-left: 16px;
  }
  .el-message-box__btns {
    padding: 25px 32px 0;
    display: flex;
    flex-direction: row-reverse;
    gap: 10px;
  }
  .el-message-box__btns button:nth-child(2) {
    margin-right: 10px;
  }
  .iconfont {
    position: absolute;
    top: -13px;
    left: 10px;
    color: #ff7f2a;
  }
  .icon-icon-xinxijingshi:before {
    font-size: 32px;
  }
  .el-button--primary:hover,
  .el-button--primary:focus {
    background: #066eb7;
    border-color: #066eb7;
  }
}
.contract-btn {
  width: 566px;

  .el-message-box__close {
    margin-top: 16px;
    margin-right: 17px;
  }
  .el-message-box__title {
    font-family: SourceHanSansCN-Medium;
    font-weight: 500;
    font-size: 16px;
    color: #16181a;
  }
  .el-message-box__message {
    color: #4f5d78;
    font-family: SourceHanSansCN-Regular;
    font-weight: 400;
    font-size: 14px;
  }
  .el-message-box__btns {
    .el-button {
      width: 216px;
      margin-top: 20px;
    }
  }
}
</style>
<style lang="scss">
  .payment-success-alert {
    padding: 30px;
  }
</style>